import IconBase from '@/data/local/json/iconsvg.json'

// const icon = () => IconBase
const icon = (theme = 'light') => IconBase.dark

export default icon
